<template>
    <div>
        <NavBarAdmin></NavBarAdmin>
        <h4 class="mt-4 mb-3">Catálogo de materias primas</h4>
        <ListRawMats @sendRawMaterialId="getRawMaterialId"></ListRawMats>
        <EditRawMaterial v-show="showEditRawMat" @hideEditRawMat="hideEditRawMat" :getRawMaterialId="rawMaterialId">
        </EditRawMaterial>
        <h4 class="mt-4 mb-3">Lista de variables generales</h4>
        <ListVariables @sendVariableId="getVariableId"></ListVariables>
        <EditVariable v-show="showEditVariable" :getVariableIdToEdit="variableId" @hideEditVariable="hideVariableEdit">
        </EditVariable>
        <FooterAdmin></FooterAdmin>
    </div>
</template>
<script>
import NavBarAdmin from "@/components/Admin/NavbarAdminComponent.vue";
import FooterAdmin from "@/components/Admin/FooterAdminComponent.vue";
import ListVariables from "@/components/Admin/Constants/ListVariablesAdminComponent.vue";
import ListRawMats from "@/components/Admin/RawMaterial/ListRawMatComponent.vue";
import EditVariable from "@/components/Admin/Constants/EditVariableAdminComponent.vue"
import EditRawMaterial from "@/components/Admin/RawMaterial/EditRawMatComponente.vue"
export default {
    data() {
        return {
            showPopUp: false,
            showEditVariable: false,
            showEditRawMat: false,
            variableId: null,
            rawMaterialId: null,
        };
    },
    components: {
        NavBarAdmin,
        FooterAdmin,
        ListVariables,
        ListRawMats,
        EditVariable,
        EditRawMaterial,
    },
    methods: {
        getVariableId(data) {
            this.variableId = data;
            //console.log(this.variableId);
            this.showEditVariable = true;
        },
        hideVariableEdit(data) {
            this.showEditVariable = data;
            this.variableId = null;
        },
        hideEditRawMat(data) {
            this.showEditRawMat = data;
            this.rawMaterialId = null;
        },
        getRawMaterialId(data) {
            this.rawMaterialId = data;
            //console.log(this.rawMaterialId);
            this.showEditRawMat = true;
        },
    },
};
</script>
